/*
 * Public API Surface of angular-responsive-carousel
 */

export * from './lib/carousel.module';
export * from './lib/carousel.component';
export * from './lib/interfaces';
